import * as React from 'react';

import { Box } from '../Box';
import { Text } from '../Text';
import { EditableField } from './EditableField';
import { TData, TRow } from './Table';
import * as remove from './delete.png';
import { Currency, formatCurrencyWithoutSymbol } from './formatCurrency';
import { Decimal, formatDecimal } from './formatDecimal';

export interface SectionRowProps {
	isEditable?: boolean;
	isCostEditable: boolean;
	updateField?: (field: string) => (value: string) => void;
	removeSection?: () => void;
	description: string;
	hours: number;
	cost: number;
	currency: Currency;
	dataTestId?: string;
	decimal?: Decimal;
}

export const GeneralHours: React.FC<SectionRowProps> = ({
	isEditable = false,
	updateField,
	removeSection,
	description,
	hours,
	cost,
	currency,
	dataTestId,
	decimal,
}) => {
	return (
		<TRow>
			<TData />
			<TData colSpan={4} align="left">
				{isEditable ? (
					<EditableField
						value={description}
						textAlign="left"
						updateField={updateField && updateField('descriptor')}
						freetext
						dataTestId={`${dataTestId}-input`}
					/>
				) : (
					<Text typography="standard" color="#0B1F2C" data-test-id={`${dataTestId}-text`}>
						{description}
					</Text>
				)}
			</TData>
			<TData align="right">
				{isEditable ? (
					<EditableField
						value={formatDecimal(hours, decimal)}
						localeSymbol={currency.symbol}
						updateField={updateField && updateField('hours')}
					/>
				) : (
					<Text typography="standard" color="#0B1F2C">
						{hours && formatDecimal(hours, decimal)}
					</Text>
				)}
			</TData>
			<TData align="right">
				<Text typography="standard" color="#0B1F2C">
					{cost && formatCurrencyWithoutSymbol(cost, currency)}
				</Text>
			</TData>
			<TData>
				{removeSection && (
					<Box
						alignItems="center"
						justifyContent="center"
						onClick={() => removeSection()}
						data-test-id={`${dataTestId}-delete-button`}
						cursor="pointer"
					>
						<img width="16px" height="16px" src={remove} alt="" />
					</Box>
				)}
			</TData>
		</TRow>
	);
};
